import { Box, HStack, Link, Text } from "@chakra-ui/react";

import * as React from "react";
import {
  Link as RouterLink,
  useLocation,
  useMatch,
  useNavigate,
} from "react-router-dom";
import {
  IMaterialIconProps,
  MaterialIcon,
} from "../components/shared/MaterialIcon";

interface NavItemProps {
  to?: string;
  label: string;
  iconName: IMaterialIconProps["name"];
  endElement?: React.ReactElement;
}

const Match = ({ path, children }) => {
  let match = useMatch(path);
  let location = useLocation();
  let navigate = useNavigate();
  return children({ match, location, navigate });
};

export const NavItem = (props: NavItemProps) => {
  const { iconName, label, endElement, to } = props;

  return (
    <Match path={`${to}`}>
      {({ match, location }) => {
        const isActive = !!match;

        return (
          <Link
            display="block"
            position="relative"
            role="group"
            userSelect="none"
            as={RouterLink}
            to={isActive && location?.pathname ? location.pathname : to}
            aria-current={isActive ? "page" : undefined}
            w="full"
            px="4"
            py="2"
            cursor="pointer"
            rounded="md"
            transition="all 0.2s"
            bg={isActive ? "sidebar.bg.active" : undefined}
            _hover={{ bg: "sidebar.bg.active" }}
            _activeLink={{ bg: "sidebar.bg.active", shadow: "sm" }}
          >
            <HStack
              color={isActive ? "inherit" : "text.main"}
              alignItems="center"
            >
              <Box>
                <MaterialIcon
                  name={iconName}
                  variant="outline"
                  fontSize="1.5rem"
                />
              </Box>
              <Text flex="1" fontWeight="inherit">
                {label}
              </Text>
              {endElement && <Box>{endElement}</Box>}
            </HStack>
          </Link>
        );
      }}
    </Match>
  );
};
